import { render, staticRenderFns } from "./ModalVentasSucursal.vue?vue&type=template&id=076bfbd2&"
import script from "./ModalVentasSucursal.vue?vue&type=script&lang=js&"
export * from "./ModalVentasSucursal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports